var React = require('react');

function Textbox (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1.000000, 2.000000)","strokeWidth":"3"},[React.createElement("path",{"d":"M12,2 L2.66666667,2 C1.19390733,2 0,3.19390733 0,4.66666667 L0,23.3333333 C0,24.8060927 1.19390733,26 2.66666667,26 L21.3333333,26 C22.8060927,26 24,24.8060927 24,23.3333333 L24,14","key":0}),React.createElement("path",{"d":"M22,0.828427083 C23.1045695,-0.276142377 24.8954305,-0.276142358 26,0.828427125 C27.1045694,1.93299661 27.1045695,3.72385758 26,4.82842708 L13.3333333,17.4950937 L8,18.8284271 L9.33333333,13.4950937 L22,0.828427083 Z","key":1})]));
}

Textbox.defaultProps = {"fill":"none","stroke":"currentColor","viewBox":"0 0 30 30"};

module.exports = Textbox;

Textbox.default = Textbox;
